module.exports = __webpack_public_path__ + "img/Elasticsearch.206b8d94.png";